import script from "./DataTypeTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTypeTab.vue?vue&type=script&setup=true&lang=js"

import "./DataTypeTab.vue?vue&type=style&index=0&id=5c449055&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c449055"]])

export default __exports__